import React from 'react';
import CityPage from '../CityPage/CityPage';
import image from './Perth.jpeg';

const PerthPage = () => (
  <CityPage
    city="Perth"
    region="Ontario"
    country="Canada"
    countryCode="CA"
    routePath="/Perth"
    currentPage="PerthPage"
    image={image}
    imageAlt="Boat rentals around Perth, Ontario on the Tay River and Rideau system"
    intro="Perth is a heritage town in eastern Ontario built around the Tay River and connected to the wider Rideau Canal system. WetRentals connects you with local boat hosts offering pontoons, fishing boats, kayaks, paddleboards and more across the surrounding lakes."
    sections={[
      {
        heading: 'Where to boat near Perth',
        body:
          'From the Tay Basin downtown you can connect to Rideau Lakes — Big Rideau, Christie Lake, Otty Lake, Bobs Lake — all popular Perth-area waters. The Rideau Canal system runs all the way from Ottawa through Westport to Kingston.',
      },
      {
        heading: 'What you can rent in Perth',
        body:
          'Pontoon boats for relaxed lake cruising, fishing boats for bass and lake trout, Sea-Doos for the bigger lakes, kayaks, canoes and paddleboards for the Tay River and quiet inland lakes.',
      },
      {
        heading: 'Why book with WetRentals in Perth',
        body:
          "WetRentals is Canada's largest peer-to-peer boat rental platform. Every booking includes safety equipment, instant confirmation, host messaging and a flexible cancellation policy.",
      },
    ]}
    searchUrl="/s?address=Perth%2C%20Ontario%2C%20Canada&bounds=45.20%2C-75.90%2C44.55%2C-76.80&mapSearch=true"
    searchLabel="Browse all boat rentals near Perth"
  />
);

export default PerthPage;
